import { render, staticRenderFns } from "./PaymentRequestTabIDInfo.vue?vue&type=template&id=618aa12a"
import script from "./PaymentRequestTabIDInfo.vue?vue&type=script&lang=js"
export * from "./PaymentRequestTabIDInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports